/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import { useTheme, Box} from '@mui/material';
import { createContext, Dispatch, SetStateAction, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Sidebar from '../common/components/Sidebar';
import Appbar from '../common/components/Appbar';
import { IUserContextModel } from '../service/model/IUserContextModel';

const root = css({
    display: "flex",
    flexDirection:"column"
})

export interface IUser {
    user: IUserContextModel,
    setUser: Dispatch<SetStateAction<IUserContextModel>>,
    userError: string[],
    setUserError: Dispatch<SetStateAction<string[]>>,
}
export const UserContext = createContext<IUser>({
    user: {
        id: "",
        email: "",
        firstName: "",
        lastName: "",
        language: "",
        fullName: "",
        mustChangePassword: false,
        modules: [],
    },
    setUser: () => { },
    userError: [],
    setUserError: () => { },
    })

const AuthorizedLayout = (): JSX.Element => {

    //##################################################################
    //########################Language Config###########################
    const { t, i18n } = useTranslation();
    //##################################################################
    //#########################User UseContext##########################
    const [user, setUser] = useState<IUserContextModel>({
        id: "",
        email: "",
        firstName: "",
        lastName: "",
        language: "",
        fullName: "",
        mustChangePassword: false,
        modules: [],
    });
    const [userError, setUserError] = useState<string[]>([]);
    const value = { user, setUser, userError, setUserError };
    //##################################################################
    const drawerWidth = "15rem";

    const theme = useTheme();

    const [mobileOpen, setMobileOpen] = useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return <UserContext.Provider value={value}>
        <div css={root}>
            <Box sx={{ display: { xs: "block", xl: "none" } }}>
                <Appbar drawerToggle={handleDrawerToggle} />
            </Box>
            <Box display="flex">
                <Box component="nav" sx={{ width: { xl: drawerWidth }, flexShrink: { sm: 0 } }}>
                    <Sidebar mobileOpen={mobileOpen} drawerToggle={handleDrawerToggle} drawerWidth={drawerWidth} />
                </Box>
                <Box component="main" sx={{ width: { xs: "100%", xl: `calc(100% - ${drawerWidth})` } }}>
                    <Outlet />
                </Box>
            </Box>
        </div>
    </UserContext.Provider>

}

export default AuthorizedLayout;